import React from 'react';
import './Service.scss';

const Service = (props) => {
  return (
      <div className="card__text">
        <h3 className="card__text_main">{props.title}</h3>
        <img src={props.image} className="services__image" alt=""/>
        <h6 className="card__text_secondary">{props.description}</h6>
      </div>
  );
};

export default Service;



// WEBPACK FOOTER //
// ./src/components/Services/Common/Service/Service.jsx